"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGroups = exports.fetchUsers = exports.fetchSecretTemplateDetails = exports.fetchSecretDetails = exports.fetchSecretList = void 0;

var _apiService = _interopRequireDefault(require("../../../../../../utils/api-service"));

var _commonConstants = require("../../../../../../utils/common-constants");

var _commonUtils = require("../../../../../../utils/common-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getRequiredString = function getRequiredString(parents) {
  if ((parents === null || parents === void 0 ? void 0 : parents.length) === 0) return '/';
  var parentsString = '';

  for (var i in parents) {
    parentsString += "/".concat(parents[i].label);
  }

  return parentsString;
};

var fetchSecretList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var parents, search, vaultId, next, _ref$filter, filter, params, requiredString, response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            parents = _ref.parents, search = _ref.search, vaultId = _ref.vaultId, next = _ref.next, _ref$filter = _ref.filter, filter = _ref$filter === void 0 ? 'co' : _ref$filter;
            params = {};
            requiredString = getRequiredString(parents);

            if (search) {
              params.filter = "name%20".concat(filter, "%20'").concat(search, "'");
            }

            if (next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(next, _commonConstants.PAGE_TOKEN);
            }

            params.path = requiredString;
            params.recursiveSecrets = true;
            params.getmetadata = true;
            _context.next = 10;
            return _apiService.default.get("/api/v1/secretmanager/vault/".concat(vaultId, "/secrets"), {
              params: params
            });

          case 10:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchSecretList(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchSecretList = fetchSecretList;

var fetchSecretDetails = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var path,
        data,
        vaultId,
        params,
        response,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            data = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            vaultId = _args2.length > 2 ? _args2[2] : undefined;
            params = {};
            params.path = path;
            _context2.next = 7;
            return _apiService.default.post("/api/v1/secretmanager/vault/".concat(vaultId, "/accesssecrets"), data, {
              params: params
            });

          case 7:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchSecretDetails() {
    return _ref3.apply(this, arguments);
  };
}();

exports.fetchSecretDetails = fetchSecretDetails;

var fetchSecretTemplateDetails = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload) {
    var id, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            id = payload.id;
            _context3.next = 3;
            return _apiService.default.get("/api/v1/secretmanager/secret-templates/static/".concat(id));

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchSecretTemplateDetails(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.fetchSecretTemplateDetails = fetchSecretTemplateDetails;

var fetchUsers = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _apiService.default.get('/api/users?type=User');

          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", (response === null || response === void 0 ? void 0 : response.data) || []);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchUsers() {
    return _ref5.apply(this, arguments);
  };
}();

exports.fetchUsers = fetchUsers;

var fetchGroups = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _apiService.default.get('/api/user-tags');

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchGroups() {
    return _ref6.apply(this, arguments);
  };
}();

exports.fetchGroups = fetchGroups;